import { Pipe, PipeTransform } from '@angular/core';
import { SimilarityList } from '../models/similarity-list';

@Pipe({
  name: 'similarityList'
})
export class SimilarityListPipe implements PipeTransform {

  transform<T extends { id: number | string }>(
    similarityList: SimilarityList<T> | null | undefined,
    similarityField: keyof T,
    threshold: number,
    labelFields: keyof T | Array<keyof T>
  ): string {
    if (!similarityList) {
      return '';
    }

    // fields to use to build the output message (firstname, lastname)
    const labels = Array.isArray(labelFields)
      ? labelFields
      : [labelFields];

    // Using the map allows to remove duplicates
    const items = Array.from(
      new Map(
        similarityList
          .matchingItems
          .concat(similarityList.similarItems)
          .filter(item =>
            typeof item[similarityField] === 'number'
            && Number(item[similarityField]) >= threshold
          )
          .map(item => [item.id, item])
      ).values()
    );

    if (items.length == 0) {
      return '';
    }

    console.debug('transform', similarityField, items)

    const names = items
      .map(item =>
        labels
          .map(field => item[field])
          .filter(v => v != null && v !== '')
          .join(' ')
      )
      .filter(name => name.length > 0);

    return names.length > 0
      ? `Possible duplicate(s) found: ${names.join(', ')}`
      : '';
  }
}
